<otto-olsen-inline-search-navbar
[configService]="configService"
class="w-90"
></otto-olsen-inline-search-navbar>
<otto-olsen-scanner-footer-menu></otto-olsen-scanner-footer-menu>